document.addEventListener("DOMContentLoaded", () => {    
    (function() {        
        const ftModesNewDesignSection = document.querySelector("#ft-modes-new-design-section");
        if (!ftModesNewDesignSection) return;
        
        const modeSelectionBtns = ftModesNewDesignSection.querySelectorAll(".mode-selection-btn");        
        const modeSelectionScreens = ftModesNewDesignSection.querySelectorAll(".mode-selection-screen");        
        const ftModeTitle = ftModesNewDesignSection.querySelector(".ft-mode-title");
        const ftModeContent = ftModesNewDesignSection.querySelector(".ft-mode-content");
        const ftModeMiddle = ftModesNewDesignSection.querySelector(".ftmodemiddle");

        const ft_progress_bar = ftModesNewDesignSection.querySelector(".ft_progress_bar");
        const ft_progress_negative = ft_progress_bar.querySelector(".ft_progress_bar_negative");
        const ft_progress_positive = ft_progress_bar.querySelector(".ft_progress_bar_positive");
        
        const ft_select_minis_plus_wrapper = ftModesNewDesignSection.querySelector(".ft_select_minis_plus_wrapper");
        const ft_select_minus_btn = ft_select_minis_plus_wrapper.querySelector(".ft_select-minus_btn");
        const ft_select_plus_btn = ft_select_minis_plus_wrapper.querySelector(".ft_select-plus_btn");

        const app_content_part = ftModesNewDesignSection.querySelector(".app-content-part");
        const ft_image_text_eyebrow = ftModesNewDesignSection.querySelector(".ft-image-text-eyebrow");
        
        let currentMode = "slow";
        let level = 0;        
        let logLock = false;

        function handleModeSpecificCode(mode, level) {            
            
            document.querySelectorAll("img[class^='ft']:not(.ft-image-text-img)").forEach(img => {
                img.style.display = "none";
            });
            ftModeMiddle.style.display = "block";
            
            let className = "";

            if (mode === "slow") {
                className = (level < 0)
                    ? `ftslown${Math.abs(level)}`
                    : `ftslow${level}`;
            }

            else if (mode === "cruise") {
                className = (level < 0)
                    ? `ftcruisen${Math.abs(level)}`
                    : `ftcruise${level}`;
            }

            else if (mode === "fast") {
                className = (level < 0)
                    ? `ftfastn${Math.abs(level)}`
                    : `ftfast${level}`;
            }

            else if (mode === "sendit") {
                className = (level < 0)
                    ? `ftsenditn${Math.abs(level)}`
                    : `ftsendit${level}`;
            }            
           
            const imgToShow = document.querySelector("." + className);

            if (imgToShow) {
                imgToShow.style.display = "block";
            } else {
                console.warn("Image not found:", className);
            }
        }

        function logStatus(eventType) {
            if (logLock) return;   
            logLock = true;       
        
            handleModeSpecificCode(currentMode, level);
            setTimeout(() => { logLock = false; }, 50);
        }
    
        const customCode = {
            slow: () => { 
                ftModeTitle.innerHTML = ftModeContent.dataset.slowtitle;
                ftModeContent.innerHTML = ftModeContent.dataset.slowcontent;
                ftModeMiddle.style.top = "10.4rem";
                ft_progress_bar.style.top = "11.6rem";
                ft_select_minis_plus_wrapper.style.top = "13.13rem";
                
                app_content_part.style.border = "5px solid green";                
            },
            cruise: () => {
                ftModeTitle.innerHTML = ftModeContent.dataset.cruisetitle;
                ftModeContent.innerHTML = ftModeContent.dataset.cruisecontent;
                ftModeMiddle.style.top = "15.4rem";
                ft_progress_bar.style.top = "16.5rem";
                ft_select_minis_plus_wrapper.style.top = "18.117rem";                
                          
                app_content_part.style.border = "5px solid #00f0ff";                
            },
            fast: () => {
                ftModeTitle.innerHTML = ftModeContent.dataset.fasttitle;
                ftModeContent.innerHTML = ftModeContent.dataset.fastcontent;
                ftModeMiddle.style.top = "20.3rem";
                ft_progress_bar.style.top = "21.4rem";
                ft_select_minis_plus_wrapper.style.top = "23.10rem";
                                               
                app_content_part.style.border = "5px solid orange";               
            },
            sendit: () => {
                ftModeTitle.innerHTML = ftModeContent.dataset.sendittitle;
                ftModeContent.innerHTML = ftModeContent.dataset.senditcontent;
                ftModeMiddle.style.top = "25.2rem";
                ft_progress_bar.style.top = "26.3rem";
                ft_select_minis_plus_wrapper.style.top = "28rem";
                                             
                app_content_part.style.border = "5px solid red";                
            }
        };

        const nextMode = {
            slow: ["cruise","fast","sendit"],
            cruise: ["slow","fast","sendit"],
            fast: ["slow","cruise","sendit"],
            sendit: ["slow","cruise","fast"]
        };

        const positions = {
            slow: ["16.4rem","21.35rem","26.3rem"],
            cruise: ["6.5rem","21.35rem","26.3rem"],
            fast: ["6.5rem","11.45rem","26.3rem"],
            sendit: ["6.5rem","11.45rem","16.4rem"]
        };

        modeSelectionBtns.forEach((btn,i)=>{
            btn.addEventListener("click",()=>changeMode(nextMode[currentMode][i]));
        });

        function updateBars() {
            const pos = level > 0 ? level * 11 : 0;
            const neg = level < 0 ? Math.abs(level) * 11 : 0;

            ft_progress_positive.style.width = pos + "%";
            ft_progress_negative.style.width = neg + "%";

            logStatus("level-change");
        }

        ft_select_plus_btn.addEventListener("click", () => {
            if (level >= 4) return; 
            if (level < 0) level++;
            else level = Math.min(4, level + 1);
            updateBars();
        });

        ft_select_minus_btn.addEventListener("click", () => {
            if (level <= -4) return; 
            if (level > 0) level--;
            else level = Math.max(-4, level - 1);
            updateBars();
        });

        function changeMode(mode){
            currentMode = mode;

            modeSelectionScreens.forEach(item=>{
                item.style.display = item.classList.contains(`app${mode}screen`) ? "flex" : "none";
            });
            
            modeSelectionBtns.forEach((btn,i)=>btn.style.top = positions[mode][i]);

            // Reset bar
            level = 0;
            ft_progress_positive.style.width = 0;
            ft_progress_negative.style.width = 0;

            customCode[currentMode]();

            logStatus("mode-change");
        }

        changeMode("slow");
        logStatus("init");

    })();
});
